export default "__VITE_ASSET__BHIV15uY__"